import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const BOAT = {
  nickname: 'PRODUCTS.BOAT.shortname',
  properties: [
    {
      name: 'boatType', key: 'BOAT_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.SAILBOAT', value: 'SAILBOAT' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.MOTORBOAT_SHAFT_PROPELLER', value: 'MOTORBOAT_SHAFT_PROPELLER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.MOTORBOAT_OUTBOARD', value: 'MOTORBOAT_OUTBOARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.MOTORBOAT_STERNDRIVE', value: 'MOTORBOAT_STERNDRIVE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.JET_SKI_WATER_JET', value: 'JET_SKI_WATER_JET' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPE.NOMOTORBOAT', value: 'NOMOTORBOAT' },
        ]
      }
    },
    {
      name: 'boatLength', key: 'BOAT_LENGTH', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^(?:[1-9]\d*(?:\.\d+)?|0\.\d*[1-9]\d*)$/)
      ]]
    },
    {
      name: 'boatRental', key: 'BOAT_RENTAL', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_RENTAL.NO_RENTAL', value: 'NO_RENTAL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_RENTAL.UP_TO_2_MONTHS_PER_YEAR', value: 'UP_TO_2_MONTHS_PER_YEAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_RENTAL.UP_TO_4_MONTHS_PER_YEAR', value: 'UP_TO_4_MONTHS_PER_YEAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_RENTAL.UP_TO_12_MONTHS_PER_YEAR', value: 'UP_TO_12_MONTHS_PER_YEAR' },
        ]
      }
    },
    {
      name: 'wtcBoatMark', key: 'TFF_VEHICLE_BRAND', group: 'OBJECT_INFO',
      isPropertyAllowedToSet: true,
      inputType: INPUT_TYPES_CONFIG.SELECT_SEARCH_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.0', value: 'AMT' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.1', value: 'Absolute' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.2', value: 'Activator' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.3', value: 'Agder' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.5', value: 'Airship Ribs' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.7', value: 'Albin' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.9', value: 'Alfa' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.11', value: 'Alicraft' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.13', value: 'Alnor' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.15', value: 'Alo Mikkel' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.17', value: 'Alusafe' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.19', value: 'Ancas Queen' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.20', value: 'Andre' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.21', value: 'Andy' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.23', value: 'Anytec' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.25', value: 'Apollo' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.27', value: 'Aquador' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.28', value: 'Aqualine' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.29', value: 'Aquatron' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.31', value: 'Arctic Blue' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.33', value: 'Ardea' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.35', value: 'Arendalsnekke' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.37', value: 'Arronet' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.39', value: 'Arvor' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.41', value: 'Askeladden' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.43', value: 'Atlantis' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.45', value: 'Atomix' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.47', value: 'Avanti' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.49', value: 'Avon' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.51', value: 'Azimut' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.53', value: 'Azure' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.55', value: 'BRIG' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.57', value: 'BRP' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.59', value: 'Baja' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.61', value: 'Balt' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.63', value: 'Barracuda' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.65', value: 'Barreta' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.67', value: 'Bavaria' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.69', value: 'Bayliner' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.70', value: 'Beach Craft' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.71', value: 'Beason' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.73', value: 'Bella' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.75', value: 'Benelli' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.77', value: 'Beneteau' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.79', value: 'Bever' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.81', value: 'Biam' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.83', value: 'Birchwood' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.85', value: 'Blackwater' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.87', value: 'Bluestar' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.89', value: 'Bolton' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.91', value: 'Bombardier' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.93', value: 'Bonanza' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.95', value: 'Bonum' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.97', value: 'Boston Whaler' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.99', value: 'Bowi Serai' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.100', value: 'Brandasund' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.101', value: 'Brekneholmen' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.103', value: 'Broom' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.105', value: 'Bryant' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.107', value: 'Buster' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.109', value: 'Camoline' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.111', value: 'Campion' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.113', value: 'Capelli' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.115', value: 'Carat' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.117', value: 'Caravelle' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.119', value: 'Carver' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.121', value: 'Cato' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.123', value: 'Celebrity' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.125', value: 'Century' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.127', value: 'Chaparral' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.129', value: 'Chris Craft' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.131', value: 'Cigarette' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.133', value: 'Classic' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.135', value: 'Cleopatra' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.137', value: 'Clipper' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.139', value: 'Coaster' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.141', value: 'Cobalt' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.143', value: 'Cobra' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.145', value: 'Colin Archer' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.147', value: 'Comet' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.149', value: 'Concord' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.151', value: 'Contrast' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.153', value: 'Cormate' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.155', value: 'Coronet' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.157', value: 'Correct Craft' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.159', value: 'Cougar' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.161', value: 'Cranchi' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.163', value: 'Crescent' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.165', value: 'Crownline' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.167', value: 'Cutwater' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.169', value: 'DSP' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.171', value: 'Dacapo' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.173', value: 'Delfin' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.175', value: 'Delta' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.177', value: 'Diana' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.178', value: 'Diplomat' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.179', value: 'Dixie' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.181', value: 'Dolmøy' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.183', value: 'Donzi' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.185', value: 'Doral' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.187', value: 'Draco' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.188', value: 'Drago' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.189', value: 'Dufour' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.191', value: 'Eikeli' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.193', value: 'Eikenes' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.195', value: 'El Diablo' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.197', value: 'Elan' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.199', value: 'Elwaro' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.201', value: 'Emili' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.203', value: 'Enes' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.205', value: 'Explorer' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.207', value: 'FM' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.209', value: 'FUN' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.211', value: 'Facil' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.213', value: 'Fairline' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.215', value: 'Falcon' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.217', value: 'Featon' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.218', value: 'Fenix' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.219', value: 'Fevik' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.221', value: 'Fiart Mare' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.223', value: 'Finnmaster' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.225', value: 'Finnsailer' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.227', value: 'Finnspeed' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.229', value: 'Finnsport' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.231', value: 'Finnvik' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.233', value: 'Fjord' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.235', value: 'Fjord Terne' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.237', value: 'Fjordling' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.239', value: 'Flem' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.241', value: 'Fletcher' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.243', value: 'Flipper' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.245', value: 'Forbina' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.246', value: 'Formula' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.247', value: 'Fountain' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.249', value: 'Four Winns' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.250', value: 'Fram' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.251', value: 'Furuholmen' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.252', value: 'GH' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.253', value: 'GP' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.255', value: 'Galaxy' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.257', value: 'Galeon' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.259', value: 'Galia' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.261', value: 'GeMi' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.263', value: 'Gimle' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.265', value: 'Glastron' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.267', value: 'Gobbi' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.269', value: 'Goldfish' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.271', value: 'Gozzi' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.273', value: 'Granada' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.275', value: 'Grand' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.277', value: 'Grand Banks' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.279', value: 'Grandezza' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.281', value: 'Greenline' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.283', value: 'Greenline Hybride' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.285', value: 'Gresvik' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.287', value: 'Grimstad' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.289', value: 'Grimsøy' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.291', value: 'Gruno Motoryachten' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.292', value: 'Gulfcraft' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.293', value: 'HB' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.295', value: 'HR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.296', value: 'Halco' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.297', value: 'Hallberg Rassy' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.299', value: 'Hankøterne' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.301', value: 'Hanse' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.303', value: 'Hansvik' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.304', value: 'Hanto' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.305', value: 'Happy' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.307', value: 'Hardanger' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.309', value: 'Harding' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.311', value: 'Hartley' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.313', value: 'Hasla' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.315', value: 'Hasle' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.317', value: 'Helle' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.319', value: 'Hero' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.320', value: 'Herwa' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.321', value: 'High Performance' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.323', value: 'Hobby' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.325', value: 'Honda' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.327', value: 'Horten' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.329', value: 'Hui' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.331', value: 'Hunter' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.333', value: 'Hurricane' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.335', value: 'Husky' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.337', value: 'Huwa' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.339', value: 'Hydra' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.341', value: 'Hydrolift' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.343', value: 'Ibiza' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.345', value: 'Infra' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.347', value: 'Inlander' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.349', value: 'Innvær' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.351', value: 'Integrity' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.353', value: 'Jans Entry' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.355', value: 'Jeanneau' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.357', value: 'Joda' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.359', value: 'Johnsen' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.360', value: 'Jørgensen' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.361', value: 'KB' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.363', value: 'Kaasbøll 19' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.365', value: 'Karnic' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.367', value: 'Kawasaki' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.369', value: 'Kimple' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.371', value: 'Kjøpstad' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.373', value: 'Kogg' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.375', value: 'Korsø' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.376', value: 'Kragerø' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.377', value: 'Krysser' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.379', value: 'Kulkuri' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.381', value: 'Kulla' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.383', value: 'Kutter' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.384', value: 'Kværnø' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.385', value: 'LM' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.387', value: 'Laguna' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.388', value: 'Larson' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.389', value: 'Libra' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.391', value: 'Lido' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.393', value: 'Linder' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.395', value: 'Linssen' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.397', value: 'Långedrag' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.399', value: 'MTI' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.401', value: 'Malo' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.403', value: 'Mamba' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.405', value: 'Marex' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.407', value: 'Mariah' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.409', value: 'Marine' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.411', value: 'Marino' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.413', value: 'Marlin' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.415', value: 'Master' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.417', value: 'Maxi' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.419', value: 'Maxum' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.421', value: 'Mekling' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.422', value: 'Menken Maritem' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.423', value: 'Merry Fisher' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.425', value: 'Merwede Kruiser' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.427', value: 'Micore' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.429', value: 'Minor' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.431', value: 'Modesty' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.432', value: 'Monaco' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.433', value: 'Montecarlo Offshore' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.435', value: 'Monterey' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.437', value: 'Moonraker' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.438', value: 'Morgan' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.439', value: 'Myra' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.441', value: 'Mørebas' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.443', value: 'Mørejet' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.445', value: 'Møring' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.447', value: 'NB Marine' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.449', value: 'Najad' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.451', value: 'Narwhal' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.453', value: 'Naurstad' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.455', value: 'Nautic' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.457', value: 'Nauticat' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.459', value: 'Navette' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.461', value: 'Neptim' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.463', value: 'Neptun' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.465', value: 'Neptunus' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.466', value: 'Nidelv' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.467', value: 'Nimbus' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.469', value: 'Nimo Offshore' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.471', value: 'Nor-Dan' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.472', value: 'Nor-Tech' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.473', value: 'Norcraft' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.474', value: 'Nord Star' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.475', value: 'Nord West' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.477', value: 'NordStar' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.478', value: 'Nordic' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.479', value: 'Nordkapp' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.481', value: 'Nordlandsbåt' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.483', value: 'Norva' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.485', value: 'Novamarin' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.487', value: 'OceanMaster' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.489', value: 'Oceancraft' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.491', value: 'Oceanrunner' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.492', value: 'Ockelbo' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.493', value: 'Ocqueteau' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.495', value: 'Olympic' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.497', value: 'Omega' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.499', value: 'Orkney' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.501', value: 'Orrskar' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.503', value: 'Osvik' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.505', value: 'Outerlimits' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.507', value: 'Paragon' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.509', value: 'Pedro' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.510', value: 'Pioner' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.511', value: 'Plattgatter' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.513', value: 'Polar' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.515', value: 'Poseidon' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.517', value: 'Posillipo' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.519', value: 'Power Quest' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.521', value: 'Powercraft' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.523', value: 'Predator' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.525', value: 'Princess' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.526', value: 'Quicksilver' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.527', value: 'Rana' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.529', value: 'Ranger Tugs' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.531', value: 'Ranieri' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.533', value: 'Regal' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.535', value: 'Relcraft' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.537', value: 'Revenger' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.539', value: 'Rhea' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.541', value: 'Ring' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.542', value: 'Rinker' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.543', value: 'Risør' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.545', value: 'River' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.547', value: 'Riviera' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.549', value: 'Rolfsnes' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.550', value: 'Rotork Sea Truck' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.551', value: 'Rupert' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.552', value: 'Ryds' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.553', value: 'Saga' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.555', value: 'Sagen' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.557', value: 'Saltø' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.558', value: 'Sandström' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.559', value: 'Sandstø' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.561', value: 'Sandvik' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.562', value: 'Sandøy' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.563', value: 'Sargo' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.565', value: 'Scand' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.566', value: 'ScandiNaval' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.567', value: 'Schaefer' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.569', value: 'Sea King' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.571', value: 'Sea Ray' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.573', value: 'Seahawk' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.575', value: 'Sealine' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.577', value: 'Sealver' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.579', value: 'Selby' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.581', value: 'Selco' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.583', value: 'Selfa' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.585', value: 'Selsbakk' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.587', value: 'Selva' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.589', value: 'Sessa' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.591', value: 'Sevik' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.593', value: 'Shark' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.595', value: 'Shetland' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.596', value: 'Sigerfjord' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.597', value: 'Silver' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.598', value: 'Silver Viking' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.599', value: 'Silverline' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.600', value: 'Silverton' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.601', value: 'Sjekte' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.602', value: 'Sjømann' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.603', value: 'Skaar' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.604', value: 'Skager' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.605', value: 'Skarpnes' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.606', value: 'Skibsplast' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.607', value: 'Skilsø' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.609', value: 'Skorgenes' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.611', value: 'Skøyte' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.613', value: 'Smart Rib' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.614', value: 'Smartliner' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.615', value: 'Smuggler' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.616', value: 'Sollux' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.617', value: 'Spjærøy' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.618', value: 'Starcraft' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.619', value: 'Steady' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.620', value: 'Stigfjord' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.621', value: 'Sting' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.622', value: 'Stingray' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.623', value: 'Stormway' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.625', value: 'Summer Family' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.627', value: 'Sundwind' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.629', value: 'Sunquest' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.631', value: 'Sunseeker' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.633', value: 'Suvi' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.634', value: 'Suzumar' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.635', value: 'Svai' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.636', value: 'Sweden Yachts' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.637', value: 'Sørlandssnekke' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.639', value: 'Targa' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.641', value: 'Terhi' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.643', value: 'Thompson' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.645', value: 'Tobias' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.647', value: 'Traveller' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.649', value: 'Tresfjord' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.651', value: 'Tromøy' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.653', value: 'Trophy' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.655', value: 'Ulvan' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.657', value: 'Unique' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.659', value: 'Uttern' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.661', value: 'Vaagen' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.663', value: 'Valiant' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.665', value: 'Vancouver' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.667', value: 'Vannsjø' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.669', value: 'Vernøy' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.671', value: 'Veslefrikk' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.673', value: 'Vestfjord' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.675', value: 'Vestkapp' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.677', value: 'Viking' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.679', value: 'Vikkilen' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.681', value: 'Viknes' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.683', value: 'Viksten' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.685', value: 'Viksund' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.687', value: 'Vindø' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.688', value: 'Wasa' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.689', value: 'Weedo' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.691', value: 'Wellcraft' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.693', value: 'West' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.695', value: 'Westbas' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.697', value: 'Westcruiser' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.699', value: 'Wester' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.700', value: 'White Shark' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.701', value: 'Wiking' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.702', value: 'Wiksten' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.703', value: 'Willys' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.704', value: 'Windjammer' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.705', value: 'Windy' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.706', value: 'Winga' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.707', value: 'Winrace' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.708', value: 'With' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.709', value: 'X-Yachts' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.710', value: 'Yamaha' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.711', value: 'Yamarin' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.712', value: 'Zitarre' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.713', value: 'Zodiac' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.714', value: 'Årø' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.715', value: 'Øien' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.716', value: 'Ørnvik' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.717', value: 'Øvrige' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.718', value: 'AB Inflatables' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.719', value: 'AB Yacht' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.720', value: 'AGA' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.721', value: 'AL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.722', value: 'Accent' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.723', value: 'Achilles' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.724', value: 'Adriatic' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.725', value: 'Adventurer' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.726', value: 'Albatross' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.727', value: 'Alloycraft' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.728', value: 'Allures' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.729', value: 'Alo' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.730', value: 'AluMarin' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.731', value: 'Alubat' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.732', value: 'Alufish' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.733', value: 'Alutec' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.734', value: 'Andunge' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.735', value: 'Aphrodite' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.736', value: 'Aqua' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.737', value: 'Aqualela' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.738', value: 'Aquamarine' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.739', value: 'Aquaquad' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.740', value: 'Aquaquick' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.741', value: 'Argo' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.742', value: 'Arimar' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.743', value: 'Astondoa' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.744', value: 'Athena' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.745', value: 'Atlantic' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.746', value: 'Axopar' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.747', value: 'BB' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.748', value: 'BIC' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.749', value: 'BMB' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.750', value: 'BWA' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.751', value: 'Ballistic' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.752', value: 'Baltic' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.753', value: 'Becker' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.754', value: 'Bell' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.755', value: 'Bennington' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.756', value: 'Berika' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.757', value: 'Black Fin' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.758', value: 'Blesser' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.759', value: 'Bombard' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.760', value: 'Bostrøm' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.761', value: 'Braveboat' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.762', value: 'Brizo Yachts' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.763', value: 'Båtsmann' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.764', value: 'Calypso' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.765', value: 'Cantieri di Sarnico' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.766', value: 'Caribe' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.767', value: 'Ciljan' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.768', value: 'Colombo' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.769', value: 'Comfort' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.770', value: 'Comfortina' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.771', value: 'Compass' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.772', value: 'Cruiser' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.773', value: 'Cruisers' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.774', value: 'Custom Line' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.775', value: 'Cyber 370' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.776', value: 'Dalla Pieta' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.777', value: 'DeFever' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.778', value: 'Dehler' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.779', value: 'Delphia' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.780', value: 'Drive' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.781', value: 'Dromeas' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.782', value: 'Dromedille' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.783', value: 'Duramar' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.784', value: 'Dynamic' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.785', value: 'Ebbtide' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.786', value: 'Edge Water' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.787', value: 'Elegance' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.788', value: 'Etap' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.789', value: 'Eurocraft' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.790', value: 'Excess catamarans' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.791', value: 'Faeton' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.792', value: 'Ferretti' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.793', value: 'Firling' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.794', value: 'Fiskeskøyte' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.795', value: 'Fjord boats' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.796', value: 'Fleming' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.797', value: 'Folla' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.798', value: 'Forgus' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.799', value: 'Formosa' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.800', value: 'Fountaine Pajot' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.801', value: 'Fourwinns' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.802', value: 'Færing' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.803', value: 'GALA' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.804', value: 'GJ' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.805', value: 'GRP' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.806', value: 'Gambling' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.807', value: 'Gemini' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.808', value: 'Gib Sea' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.809', value: 'Gjeving' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.810', value: 'Gliseris' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.811', value: 'Grady-White' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.812', value: 'Grand Soleil' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.813', value: 'Green Waves' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.814', value: 'Grinde' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.815', value: 'H-Båt' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.816', value: 'Hardangersnekke' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.817', value: 'Hasle Summer Fun' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.818', value: 'Hastig' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.819', value: 'Havboat' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.820', value: 'Hawk' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.821', value: 'Herva' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.822', value: 'HeyDay' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.823', value: 'HighPerformance' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.824', value: 'Highfield' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.825', value: 'Hitra' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.826', value: 'Hobiecat' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.827', value: 'Hortensnekka' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.828', value: 'Hurrycane' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.829', value: 'Hutting' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.830', value: 'Hydromarin' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.831', value: 'Hydrosport' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.832', value: 'Hårek' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.833', value: 'IF' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.834', value: 'IRON Boats' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.835', value: 'ISY' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.836', value: 'In Lander' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.837', value: 'Inter' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.838', value: 'Invictus' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.839', value: 'Irene' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.840', value: 'Italia Yachts' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.841', value: 'J-boats' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.842', value: 'Jaguar' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.843', value: 'Janmor' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.844', value: 'Johnson' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.845', value: 'Joker' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.846', value: 'Jolly' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.847', value: 'Junker' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.848', value: 'KB Snekke' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.849', value: 'KMV' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.850', value: 'Kaasbøll' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.851', value: 'Kaisla' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.852', value: 'Karmøy' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.853', value: 'Kavaler' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.854', value: 'Kloster' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.855', value: 'Knarr' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.856', value: 'LN' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.857', value: 'Lagoon' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.858', value: 'Lami' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.859', value: 'Laser' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.860', value: 'Lasse' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.861', value: 'Lextor Marin' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.862', value: 'Lodestar' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.863', value: 'Lomac' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.864', value: 'Los' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.865', value: 'Luna' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.866', value: 'Lyngør' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.867', value: 'Lærling' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.868', value: 'MS Boat' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.869', value: 'MV yachts' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.870', value: 'Maestral' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.871', value: 'Magnum' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.872', value: 'Mainship' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.873', value: 'Majesty' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.874', value: 'Malø Yachts' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.875', value: 'Marieholm' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.876', value: 'Maril' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.877', value: 'Mariner' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.878', value: 'Mazury' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.879', value: 'Melges' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.880', value: 'Mercury' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.881', value: 'Mery Nautic' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.882', value: 'Mikkel' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.883', value: 'Monark' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.884', value: 'Moody' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.885', value: 'Motiva' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.886', value: 'Musling' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.887', value: 'NB' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.888', value: 'Nautico' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.889', value: 'Naver' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.890', value: 'Nessy' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.891', value: 'Nicholson' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.892', value: 'Nilsen' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.893', value: 'Nimo' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.894', value: 'Nor Sea' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.895', value: 'Nor Star' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.896', value: 'Norbas' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.897', value: 'Norbåt' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.898', value: 'Nordic Ocean Craft' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.899', value: 'Nordisk folkebåt' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.900', value: 'Norline' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.901', value: 'Norman' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.902', value: 'Norsafe' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.903', value: 'NorthStar' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.904', value: 'Northmaster' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.905', value: 'OX' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.906', value: 'Oselvar' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.907', value: 'Otasport' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.908', value: 'Paramount Powerboats' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.909', value: 'Pershing' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.910', value: 'Pettersson' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.911', value: 'Polarcirkel' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.912', value: 'PowerQuest' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.913', value: 'Prestige' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.914', value: 'Pro Rib' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.915', value: 'ProWorker' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.916', value: 'Puma' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.917', value: 'RM-Yachts' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.918', value: 'Racing Sailboats' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.919', value: 'Ramin' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.920', value: 'Ran Craft' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.921', value: 'Rand' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.922', value: 'Ranger' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.923', value: 'Rascala' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.924', value: 'Rib Limited' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.925', value: 'Ribeye' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.926', value: 'Riva' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.927', value: 'Rivena Yachts' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.928', value: 'Rodman' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.929', value: 'SUN' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.930', value: 'Saver' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.931', value: 'Saxdor' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.932', value: 'Scampi' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.933', value: 'Scandinavien' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.934', value: 'Scanmar' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.935', value: 'Scarani' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.936', value: 'Schaefer Yachts' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.937', value: 'Sea Force One' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.938', value: 'Sea Master' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.939', value: 'Sea Star' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.940', value: 'SeaDan' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.941', value: 'SeaDoo' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.942', value: 'SeaHunter' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.943', value: 'Seabird' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.944', value: 'Seaco' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.945', value: 'Seacore' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.946', value: 'Seaking' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.947', value: 'Sealegs' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.948', value: 'Seamarin' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.949', value: 'Seaside' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.950', value: 'Seigur' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.951', value: 'Shakespeare' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.952', value: 'Sirena' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.953', value: 'Sjark' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.954', value: 'Skagerak' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.955', value: 'Skarsvåg' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.956', value: 'Skater' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.957', value: 'Skipper' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.958', value: 'Smiling' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.959', value: 'Solaris' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.960', value: 'Spornes' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.961', value: 'Sporty' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.962', value: 'Starfisher' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.963', value: 'Storebro' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.964', value: 'Strana' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.965', value: 'Strandebarmer' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.966', value: 'Style' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.967', value: 'Sun Odyssey' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.968', value: 'Sun Quest' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.969', value: 'Sunbeam' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.970', value: 'Sunrider' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.971', value: 'Sunwind' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.972', value: 'Sur Marine' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.973', value: 'SurPlus' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.974', value: 'Swan' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.975', value: 'Sørlandssnekka' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.976', value: 'TB' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.977', value: 'TG-Boat' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.978', value: 'TS Boats' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.979', value: 'Tahoe' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.980', value: 'Takacat' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.981', value: 'Technohull' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.982', value: 'Tecnorib' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.983', value: 'Tethys Yachts' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.984', value: 'Tetis' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.985', value: 'Tiger Marine' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.986', value: 'Trader' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.987', value: 'Trawler' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.988', value: 'Trintella' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.989', value: 'Trio' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.990', value: 'Tristan' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.991', value: 'Triton' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.992', value: 'Troll' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.993', value: 'Trønder' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.994', value: 'Tustna' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.995', value: 'UMS' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.996', value: 'V - Boats' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.997', value: 'Vest' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.998', value: 'Viko Yachts' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.999', value: 'Vira' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.1000', value: 'Vista' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.1001', value: 'Walker Bay' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.1002', value: 'Wesling' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.1003', value: 'Westline' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.1004', value: 'Westplast' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.1005', value: 'Williams' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.1006', value: 'Willing' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.1007', value: 'X - Yachts' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.1008', value: 'XO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.1009', value: 'Yam' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.1010', value: 'Yngling' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.1011', value: 'ZAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.1012', value: 'Zebec' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_TYPES.1013', value: 'Annet' },
        ]
      }
    },
    {
      name: 'boatBuiltYear', key: 'BUILD_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN_TYVERI', value: 'BRANN_TYVERI' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' },
        ]
      }
    },
    {
      name: 'vehicleEngineHP', key: 'BOAT_ENGINE_HP', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'wtcBoatMotorAge', key: 'BOAT_MOTOR_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    {
      name: 'buildingMaterial', key: 'BUILDING_MATERIALS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_BUILDING_MATERIALS.WOOD', value: 'WOOD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_BUILDING_MATERIALS.STEEL_PLASTIC_FIBERGLASS', value: 'STEEL_PLASTIC_FIBERGLASS' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_BUILDING_MATERIALS.RIB', value: 'RIB' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_BUILDING_MATERIALS.ALUMINIUM', value: 'ALUMINIUM' },
        ]
      }
    },
    {
      name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['']
    },
    {
      name: 'driverLicenseYearCount', key: 'DRIVER_LICENSE_YEAR_COUNT', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'wtcBoatYoungUser', key: 'WTC_BOAT_YOUNG_USER', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'wtcBoatTracker', key: 'WTC_TRACKER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'boatHarborPermanentSecurity', key: 'HARBOR_PERMANENT_SECURITY_TTFINANS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'organizedMarina', key: 'ORGANIZED_MARINA', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'boatSecurityHasSecurmark', key: 'SECURITY_HAS_SECUREMARK_TTFINANS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'boatMemberOfCoastalPatrol', key: 'BOAT_MEMBER_OF_COASTAL_PATROL', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'boatVhfOnBoard', key: 'BOAT_VHF_ON_BOARD', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'boatTheftProtection', key: 'BOAT_THEFT_PROTECTION', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'wtcBoatMotorMark', key: 'BOAT_MOTOR_MARK', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'boatWinterStorage', key: 'BOAT_WINTER_STORAGE_TTFINANS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'boatHarborLocation', key: 'HARBOR_LOCATION', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HARBOR_LOCATION.OSTFOLD', value: 'OSTFOLD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HARBOR_LOCATION.AKERSHUS', value: 'AKERSHUS' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HARBOR_LOCATION.AGDER', value: 'AGDER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HARBOR_LOCATION.BUSKERUD', value: 'BUSKERUD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HARBOR_LOCATION.FINNMARK', value: 'FINNMARK' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HARBOR_LOCATION.INNLANDET', value: 'INNLANDET' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HARBOR_LOCATION.VESTLAND', value: 'VESTLAND' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HARBOR_LOCATION.MORE_OG_ROMSDAL', value: 'MORE_OG_ROMSDAL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HARBOR_LOCATION.TRONDELAG', value: 'TRONDELAG' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HARBOR_LOCATION.NORDLAND', value: 'NORDLAND' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HARBOR_LOCATION.OSLO', value: 'OSLO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HARBOR_LOCATION.ROGALAND', value: 'ROGALAND' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HARBOR_LOCATION.SVALBARD', value: 'SVALBARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HARBOR_LOCATION.TELEMARK', value: 'TELEMARK' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HARBOR_LOCATION.TROMS', value: 'TROMS' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HARBOR_LOCATION.VESTFOLD', value: 'VESTFOLD' },
        ]
      }
    },
    {
      name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.5', value: '5000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.7.5', value: '7500' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.15', value: '15000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.20', value: '20000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.25', value: '25000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.30', value: '30000' },
        ]
      }
    },
    {
      name: 'vehicleDriverAccident', key: 'VEHICLE_DRIVER_ACCIDENT', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleMortage', key: 'VEHICLE_MORTAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleLeasing', key: 'VEHICLE_LEASING', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleExtendedMechanicalDamageCover', key: 'VEHICLE_EXTENDED_MECHANICAL_DAMAGE_COVER', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
  ],
  icon: 'boat'
};
